import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

// Security PIN endpoints, same contract as Android/iOS (app-platform/auth AuthRemoteSource):
// the server keeps the PIN and hands back a checksum the client compares against locally.
const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const api = new ApiService(`${getEnvConfig('WEB_BASE_URL')}/auth`, headers)
api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

// Mobile calls auth/v3/password; through the web gateway that route answers 401 to a valid
// web session, while v1.0 serves the same contract (checked on staging 2026-10-01).
const PASSWORD_ENDPOINT = '/v1.0/password'

// The OTP calls are unauthenticated on mobile too
const otpApi = new ApiService(`${getEnvConfig('WEB_BASE_URL')}/auth`, {
  'content-type': 'application/json',
  accept: '*/*'
})
const OTP_REQUEST_ENDPOINT = '/v1.0/otp:request'
const OTP_VERIFY_ENDPOINT = '/v1.0/otp:verify'
// Mobile tags every OTP with the flow it belongs to
export const OTP_FLOW_CHANGE_PIN = 'Change Pin'
export const OTP_FLOW_RECOVERY_NUMBER = 'Add Recovery Number'
// KMP VerifyAndChangeMobileNumber: the current number's OTP and the new number's OTP
export const OTP_FLOW_CHANGE_NUMBER = 'Number Changed'
export const OTP_FLOW_VERIFY_NEW_NUMBER = 'Verify New Number Changed'

// → { password_set: boolean, checksum?: string }
export const getPasswordStatus = () =>
  api.getRequest(PASSWORD_ENDPOINT, {}, undefined, {
    timeout: 3000
  })

export const setPassword = (pin: string) => api.postRequest(PASSWORD_ENDPOINT, { password: pin })

// → { otp_id }
export const requestPinOtp = (mobile: string, flowType: string = OTP_FLOW_CHANGE_PIN) =>
  otpApi.postRequest(OTP_REQUEST_ENDPOINT, { mobile, mode: 0, otp_flow_type: flowType })

// → { token }
export const verifyPinOtp = (otpId: string, otp: string, flowType: string = OTP_FLOW_CHANGE_PIN) =>
  otpApi.postRequest(OTP_VERIFY_ENDPOINT, {
    mode: 0,
    otp_id: otpId,
    otp,
    otp_flow_type: flowType
  })
